export default __webpack_public_path__ + "static/media/eager.1abb01e3.svg";